import api from './api'

const BASE_URL = '/api/v1/perfil'

/**
 * Perfil do próprio usuário. O backend deriva quem é do token — não há (nem deve haver)
 * parâmetro de usuário aqui.
 */
export interface Perfil {
  // Identidade — leitura; quem altera é o ADMIN em /usuarios.
  id: string
  nome: string
  email: string
  cpf?: string | null
  cnpj?: string | null
  tenantId?: string | null
  tipoCanal?: string | null

  // Mantidos pelo próprio usuário.
  telefone?: string | null
  celular?: string | null
  cep?: string | null
  logradouro?: string | null
  numero?: string | null
  complemento?: string | null
  bairro?: string | null
  cidade?: string | null
  uf?: string | null
  banco?: string | null
  agencia?: string | null
  conta?: string | null
  tipoConta?: string | null
  chavePix?: string | null
  formacao?: string | null
  historicoProfissional?: string | null
  emailProfissional?: string | null
}

/** O PUT envia o perfil inteiro: campo em branco apaga o dado. */
export type PerfilRequest = Omit<
  Perfil,
  'id' | 'nome' | 'email' | 'cpf' | 'cnpj' | 'tenantId' | 'tipoCanal'
>

export const perfilService = {
  obter: async (): Promise<Perfil> => {
    const response = await api.get<Perfil>(BASE_URL)
    return response as unknown as Perfil
  },

  salvar: async (request: PerfilRequest): Promise<Perfil> => {
    const response = await api.put<Perfil>(BASE_URL, request)
    return response as unknown as Perfil
  },
}
